import axiosInstance from '../config/axios';
import { API_ENDPOINTS } from '../config/api';

const base = API_ENDPOINTS.auditLogs;

export async function getAuditLogs(filters = {}, { page = 1, limit = 25 } = {}) {
  const res = await axiosInstance.get(base, { params: { ...filters, page, limit } });
  return res.data;
}

export async function getAuditLogById(id) {
  const res = await axiosInstance.get(`${base}/${id}`);
  return res.data;
}

export async function exportAuditLogsCsv(filters = {}) {
  const res = await axiosInstance.get(`${base}/export`, {
    params: filters,
    responseType: 'blob'
  });
  return res.data;
}

export async function getDocumentAuditLog(documentId, { page = 1, limit = 100 } = {}) {
  const res = await axiosInstance.get(API_ENDPOINTS.documentAuditLog(documentId), { params: { page, limit } });
  return res.data;
}
